import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LuciTreeComponent } from './luci-tree.component';



@NgModule({
  declarations: [LuciTreeComponent],
  exports: [LuciTreeComponent],
  imports: [
    CommonModule
  ]
})
export class LuciTreeModule { }
